const pad5 = (n) => String(Math.max(0, Math.floor(Number(n) || 0))).padStart(5, '0');

/**
 * Build label barcode for print.
 * - mode off → product.barcode
 * - weight + on → weightPrefix + weightCode(5) + qty*1000(5)
 * - kit + on → kitPrefix + weightCode(5) + kitQty(5)
 */
export const buildLabelBarcode = ({
  product,
  modeEnabled,
  isWeight,
  quantity,
  weightPrefix = '22',
  kitPrefix = '23',
}) => {
  const plain = String(product?.barcode || '').trim();
  if (!modeEnabled) return plain;

  const weightCode = pad5(product?.weightCode ?? 0);
  if (isWeight) {
    const qtyPart = pad5(Math.round(Number(quantity || 0) * 1000));
    return `${String(weightPrefix || '')}${weightCode}${qtyPart}`;
  }
  const kitPart = pad5(quantity);
  return `${String(kitPrefix || '')}${weightCode}${kitPart}`;
};

export const buildLabelPayload = ({
  product,
  modeEnabled,
  isWeight,
  quantity,
  copies,
  weightPrefix,
  kitPrefix,
}) => {
  const barcode = buildLabelBarcode({
    product,
    modeEnabled,
    isWeight,
    quantity,
    weightPrefix,
    kitPrefix,
  });
  const code = String(product?.code || product?.article || '').trim();
  const name = String(product?.name || '').trim();
  let qtyText = '';
  if (modeEnabled) {
    if (isWeight) {
      const q = Number(quantity);
      qtyText = Number.isFinite(q) ? `${q.toFixed(3)} кг` : '';
    } else {
      qtyText = `${Math.max(0, Math.floor(Number(quantity) || 0))} шт`;
    }
  }
  return {
    code,
    name,
    qtyText,
    barcode,
    copies: Math.max(1, Math.floor(Number(copies) || 1)),
  };
};
